import type { configurationCreationStep } from "../CreateConfigurationDrawer";
import { makeStyles } from "@fluentui/react-components";
import { ProgressIndicatorStep } from "./ProgressIndicatorStep";

export interface IProgressIndicatorProps {
    currentProgress: configurationCreationStep;
}

const buildOuterStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: '40px'
    }
});

const steps = ["application", "settings", "users", "finish"] as const;


export function ProgressIndicator(props: Readonly<IProgressIndicatorProps>) {
    const { currentProgress } = props;

    const styles = buildOuterStyles();
    const currentIndex = steps.indexOf(currentProgress);

    return (
        <div className={styles.container} >
        {
            steps.map((step, index) => <ProgressIndicatorStep key={step}
                                                              step={step}
                                                              currentIndex={currentIndex} 
                                                              stepIndex={index} />)
        }
        </div>
    );
};